import create from 'zustand';

interface IModalUnavailableStore {
  visible: boolean;
  show: () => void;
  hide: () => void;
}

const modalUnavailableStore = create<IModalUnavailableStore>((set) => ({
  visible: false,
  show: () => {
    set({ visible: true });
  },
  hide: () => {
    set({ visible: false });
  },
}));

export {
  modalUnavailableStore,
};
